import React, { Component } from 'react';
import { Badge, Button, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row } from 'reactstrap';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Waiting from './../../modules/waiting';
import SimpleHeader from './../../modules/simpleHeader_new';
import Message from './../errors/message';
import paymobArrowImg from './../../../statics/img/paymob-arrow.png';
// import * as paymob from './paymob'; 
import './flash_checkout.css';

class flash_checkout extends Component {
    constructor(props){
        super(props);
        this.state = {
            waiting: true,
            public_key: "",
            clientSecret: "",
            order: {},
            requestComplete: false,
            completeMessage: {'head': "", 'body': ""},
        };
    }
    componentDidMount(){
        this.load_data();
    }
    load_data = () => {
        var search = window.location.search.substring(1);
        let token = search.substr(6);
        let invoiceUrl = appConfig.getServerUrl() + '/api/next/v1/invoice';
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        let data = {
            "token": token
        }
        let dataDict = JSON.stringify(data);
        axios.post(
            invoiceUrl,
            dataDict,
            config
        )
        .then((resp)=>{
            this.setState({
                waiting: false,
                order: resp.data.order,
                public_key: resp.data.public,
                clientSecret: resp.data.client
            })
        })
        .catch((err)=>{
            // 404 Order not found
            // 422 Merchant not onboarded
            // 406 Order expired
            // 429 Request throttled
            this.setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
        });
    }
    setReqComplete = (Message) => {
        this.setState({requestComplete: true, completeMessage: Message, waiting: false});
    }
    renderComplete = () => {
        return(
            <div class="newStandalone">
                <div className="invoice">
                    <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                    <div className="companyDetails">
                        <div className="compLogo">
                            {this.state.userData && this.state.userData.logo_uri&&
                                <img src={appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                            }
                        </div>
                    </div>
                    <div className="standaloneBody">
                    <Message head={this.state.completeMessage.head} body={this.state.completeMessage.body} sympl={this.state.completeMessage.sympl} sympl_data={this.state.completeMessage.sympl_data} />
                    </div>
                </div>
            </div>
        )
    }
    renderBody = () => {
        return(
            <div>
                {this.state.requestComplete ?
                    this.renderComplete()
                :
                    <div className="flash_container">
                        {this.state.order.data && this.state.order.data.logo &&
                            <div className="flash_logo">
                                <img src={this.state.order.data.logo} alt="merchant logo" />
                            </div>
                        }
                        <p className="flash_product_desc">{this.state.order.data.description}</p>
                        {["JOD", "OMR", "KWD"].includes(this.state.order.currency) ?
                            <p className="flash_product_price">{this.state.order.amount_cents / 1000} {this.state.order.currency}</p>
                        :
                            <p className="flash_product_price">{this.state.order.amount_cents / 100} {this.state.order.currency}</p>
                        }
                        {this.state.order.data && this.state.order.data.product_image &&
                            <img className="flash_product_img" src={this.state.order.data.product_image} alt="prduct image" />
                        }
                        {
                            (
                                (this.state.order.shipping_data && this.state.order.shipping_data.name) ||
                                (this.state.order.shipping_data && this.state.order.shipping_data.email) ||
                                (this.state.order.shipping_data && this.state.order.shipping_data.phone_number)
                            ) 
                        &&
                            <div className="flash_product_info_div">
                                <p className="flash_product_info_title">Customer Info</p>
                                {this.state.order.shipping_data.name && <p className="flash_product_info"><span>Name: </span>{this.state.order.shipping_data.name}</p>}
                                {this.state.order.shipping_data.email && <p className="flash_product_info"><span>Email: </span>{this.state.order.shipping_data.email}</p>}
                                {this.state.order.shipping_data.phone_number && <p className="flash_product_info"><span>Phone Number: </span>{this.state.order.shipping_data.phone_number}</p>}
                            </div>
                        }
                        <div id="paymob-checkout">
                            {(this.state.public_key && this.state.clientSecret) && 
                                <a id="move_to_checkout_btn" className="custom_flash_pay_btn" href={appConfig.getServerUrl() + `/unifiedcheckout/?publicKey=${this.state.public_key}&clientSecret=${this.state.clientSecret}`} target="_self">
                                    <span>
                                        Checkout with <svg width="78.273" height="18" fill="white" viewBox="0 0 76.363 17"><g transform="translate(-52.322 -291.752)"><path d="M268.379,281.469a5.973,5.973,0,0,0-6.246,3.987,3.916,3.916,0,0,0,3.263,5.292,5.974,5.974,0,0,0,6.247-3.986,3.917,3.917,0,0,0-3.263-5.293m.855,4.962a2.894,2.894,0,0,1-3.116,1.962,1.866,1.866,0,0,1-1.577-2.607,2.893,2.893,0,0,1,3.116-1.963,1.868,1.868,0,0,1,1.577,2.608" transform="translate(-157.931 14.1)"></path><path d="M215.779,281.043h-.137a5.754,5.754,0,0,0-3.651,1.53,3.6,3.6,0,0,0-3.1-1.534h-3.353a1.6,1.6,0,0,0-1.578,1.324l-1.459,8.275h2.431l1.186-6.727a.534.534,0,0,1,.526-.441h1.539a2.018,2.018,0,0,1,1.917,2.559c-.212,1.2-.8,4.609-.8,4.609h2.431s.636-3.6.848-4.8c.01-.056.018-.112.026-.167a2.9,2.9,0,0,1,2.541-2.19,2.028,2.028,0,0,1,1.72,2.548c-.212,1.2-.8,4.609-.8,4.609h2.431l.848-4.8c.46-2.608-.989-4.728-3.559-4.8" transform="translate(-116.203 14.368)"></path><path d="M141.51,281.039h-2.372a5.974,5.974,0,0,0-5.646,4.8,3.916,3.916,0,0,0,3.953,4.8,3.523,3.523,0,0,0,2.585-1.206l-.212,1.206h2.431l1.364-7.737a1.587,1.587,0,0,0-1.562-1.862Zm-.849,4.8a2.894,2.894,0,0,1-2.82,2.368,1.866,1.866,0,0,1-1.917-2.368,2.893,2.893,0,0,1,2.82-2.369h1.392a.793.793,0,0,1,.781.931l-.253,1.432Z" transform="translate(-67.677 14.369)"></path><path d="M337.064,308.713h-.391l-.191,1.232h-.206l.191-1.232h-.391l.029-.19h.987Zm1.435,1.232h-.206l.184-1.187h-.006l-.592,1.187h-.13l-.225-1.187h-.006l-.184,1.187h-.206l.22-1.421h.318l.205,1.08.534-1.08h.315Z" transform="translate(-210.035 -4.937)"></path><path d="M110.588,281.037l-3.845,0a2.614,2.614,0,0,0-2.692,2.427h5.173s.7,0,.55.786l-.892,5.122a5.422,5.422,0,0,0,1.816-.8h0a2.991,2.991,0,0,0,1.066-1.785l.586-3.873a1.654,1.654,0,0,0-1.761-1.885" transform="translate(-47.049 14.37)"></path><path d="M91.836,288.211v0l1.275-7.168h-.561a2.258,2.258,0,0,0-2.224,1.866l-2.006,11.387h2.432l.65-3.655v0h3.313c2.921,0,2.994-2.423,2.994-2.423Z" transform="translate(-36 14.368)"></path><path d="M170.743,291.644l-.323,2.415s6.326,2.155,7.726-4.683l1.509-8.34h-2.495l-.761,4.208a3.279,3.279,0,0,1-3.188,2.6s-1.845.174-1.42-2.2l.823-4.609h-2.494l-.868,4.8s-.682,3.321,2.043,4.446c0,0,2.666,1.166,4.3-1.039,0,0,.1,3.66-4.848,2.4" transform="translate(-92.795 14.37)"></path><path d="M298.269,279.579l1.926-10.827h-.56a2.259,2.259,0,0,0-2.225,1.867l-2.006,11.387,5.714,0c2.921,0,2.995-2.423,2.995-2.423Z" transform="translate(-181.465 23)"></path><path d="M315.377,281.037l-3.845,0a2.614,2.614,0,0,0-2.693,2.427h5.173s.7,0,.55.786l-.891,5.122a5.419,5.419,0,0,0,1.815-.8h0a2.99,2.99,0,0,0,1.065-1.785l.586-3.873a1.654,1.654,0,0,0-1.761-1.885" transform="translate(-190.901 14.37)"></path></g></svg>
                                    </span>
                                    <img src={paymobArrowImg} alt="paymob-arrow" />
                                </a>
                            }
                        </div>
                    </div>
                }
            </div>
        )
    }
    render(){
        return (
            <div>
                {!this.state.waiting ? this.renderBody() : <Waiting height='100vh'/> }
            </div>
        );
    }
    
}

export default flash_checkout;